export default __webpack_public_path__ + "static/chocpops-health-3-mobile-86f0c80583977ab0fb7adf4ba534084d.png";